import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as templateConfigActions from './template-config.actions';
import { TemplateConfig } from 'src/app/models/template-config';

export interface TemplateConfigState extends EntityState<TemplateConfig> {
  loadingTemplateConfig: boolean;
  templateConfigLoaded: boolean;
  templateConfig: TemplateConfig;
}

export const templateConfigAdapter: EntityAdapter<TemplateConfig> = createEntityAdapter<TemplateConfig>({});

export const initialSubsectionState: TemplateConfigState = templateConfigAdapter.getInitialState({
  loadingTemplateConfig: false,
  templateConfigLoaded: false,
  templateConfig: null,
});

export const reducer = createReducer(
  initialSubsectionState,
  on(templateConfigActions.getTemplateConfiguration, (state) => {
    return {
      ...state,
      loadingTemplateConfig: true,
      templateConfigLoaded: false,
    };
  }),
  on(templateConfigActions.getTemplateConfigurationSuccess, (state, { templateConfig }) => {
    return templateConfigAdapter.setOne(templateConfig, {
      ...state,
      loadingTemplateConfig: false,
      templateConfigLoaded: true,
      templateConfig,
    });
  }),
  on(templateConfigActions.getTemplateConfigurationError, (state) => {
    return {
      ...state,
      loadingTemplateConfig: false,
      templateConfigLoaded: false,
      templateConfig: null,
    };
  })
);

export function TemplateConfigReducer(state: TemplateConfigState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = templateConfigAdapter.getSelectors();
